/**
 * Every list this console reads is AUDITED with a stated reason (the API asks for 10 to 500 characters). The lists now open
 * straight away: when the person looking has not typed a reason of their own, this fixed one is sent - the audit trail still
 * records who read what and when, and an operator who wants a precise purpose on record types it in the field, which then
 * replaces this one.
 *
 * Reads only: the actions (suspend, reset a password, assign...) keep asking for their own reason in their dialog.
 */
export const DEFAULT_CONSULTATION_REASON =
  "Consultation courante depuis la console d'administration";

export function consultationReason(typed: string): string {
  const trimmed = typed.trim();
  return trimmed.length >= 10 ? trimmed : DEFAULT_CONSULTATION_REASON;
}
